import { Component, Input, EventEmitter, Output,
    ChangeDetectionStrategy
} from '@angular/core';
import { FrontendForm } from '../../netgen/FrontendForm';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
@Component({
    selector: 'app-crud-edit',
    templateUrl: './crud-edit.component.html',
    styleUrls: ['./crud-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CrudEditComponent extends ComponentView {

    @Input()
    form: FrontendForm;

    @Output()
    save = new EventEmitter();

    saveInternal(): void {
        this.save.emit(null);
    }

    cancel(): void {
        this.app.navigateBack();
    }

}
